import type { Object as FabricObject } from 'fabric/fabric-impl';
import { ShootoutAttempt } from 'shared/types/shootout';
import { theme } from 'styles/theme/theme';

/**
 * Раскраска цепочки ударов серии пенальти. Отдельный модуль, а не метод плейсхолдера:
 * теми же правилами красит и редактор (превью в правой панели), и оверлей в эфире,
 * а тянуть в замену класс плейсхолдера вместе с интерактивной канвой ни к чему.
 */

export interface ShootoutColors {
  goalColor: string;
  missColor: string;
  pendingColor: string;
}

export const DEFAULT_SHOOTOUT_COLORS: ShootoutColors = {
  goalColor: theme.colors.Green,
  missColor: theme.colors.Red,
  pendingColor: theme.colors.Gray,
};

export function getShootoutColors(data?: Partial<ShootoutColors> | null): ShootoutColors {
  return {
    goalColor: data?.goalColor || DEFAULT_SHOOTOUT_COLORS.goalColor,
    missColor: data?.missColor || DEFAULT_SHOOTOUT_COLORS.missColor,
    pendingColor: data?.pendingColor || DEFAULT_SHOOTOUT_COLORS.pendingColor,
  };
}

/**
 * Показательная серия для редактора: пока матча нет, все удары были бы непробитыми,
 * и два из трёх цветов оператор не увидел бы вовсе.
 */
export function previewShootoutAttempts(maxCount: number): ShootoutAttempt[] {
  const preview: ShootoutAttempt[] = ['GOAL', 'MISS'];
  return preview.slice(0, Math.max(0, maxCount));
}

export function getShootoutColor(attempt: ShootoutAttempt | undefined, colors: ShootoutColors): string {
  if (attempt === 'GOAL') return colors.goalColor;
  if (attempt === 'MISS') return colors.missColor;
  return colors.pendingColor;
}

/** Красит ряд индикаторов по фактическим ударам; хвост остаётся «непробитым». */
export function paintShootoutIndicators(indicators: FabricObject[], attempts: ShootoutAttempt[], colors: ShootoutColors) {
  indicators.forEach((indicator, index) => {
    indicator.set({ fill: getShootoutColor(attempts[index], colors) });
  });
}
